// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./wood-background.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./registration-background.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

#artful-client {
  height: 100%;
}
@media (max-width: 768px) {
  #artful-client {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 768px) {
  .ReactModal__Body--open #artful-client {
    overflow-y: unset;
  }
}

.application-background {
  padding: 1rem 0 0 0;
  background: linear-gradient(white, #efefef);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  min-height: calc(100% - 6rem);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  top: 0;
}
@media (min-width: 1024px) {
  .application-background {
    padding: 1.5rem 6.5rem;
  }
}
.application-background.feature-flag-registration {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  justify-content: center;
}
@media (max-width: 1023px) {
  .application-background.feature-flag-registration {
    padding: 0;
  }
}
.application-background.registration {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: top;
  display: flex;
}
.application-background.app-loading {
  min-height: 100%;
}
.application-background.edge .skin-wrapper {
  position: relative;
  min-height: calc(100% - 10.5rem);
}
.application-background.edge .skin-wrapper .date-tabs-wrapper {
  min-height: calc(100% - 12.5rem);
}
.application-background.edge .skin-wrapper .date-tabs-wrapper .split-page {
  min-height: calc(100% - 12.5rem);
}
.application-background.edge .skin-wrapper .date-tabs-wrapper .split-page > .flex-row {
  min-height: calc(100% - 12.5rem);
}
.application-background.edge .skin-wrapper .date-tabs-wrapper .split-page > .flex-row .page-right,
.application-background.edge .skin-wrapper .date-tabs-wrapper .split-page > .flex-row .page-left {
  height: unset;
}

.referral-popup,
.trial-popup,
.mobile-popup,
.tracking-popup {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(171, 58, 114, 0.9);
  padding: 2rem 2rem;
  z-index: 4;
  width: 75rem;
  margin: 0 auto;
  color: white;
  text-align: center;
  font-size: 1.6rem;
}
@media (max-width: 750px) {
  .referral-popup,
  .trial-popup,
  .mobile-popup,
  .tracking-popup {
    width: 100%;
  }
}
.referral-popup__header,
.trial-popup__header,
.mobile-popup__header,
.tracking-popup__header {
  font-size: 2.5rem;
  text-transform: uppercase;
  color: #dabc64;
  font-weight: 600;
  margin-bottom: 1rem;
}
.referral-popup__body__code,
.trial-popup__body__code,
.mobile-popup__body__code,
.tracking-popup__body__code {
  font-weight: 600;
}
.referral-popup__body p,
.trial-popup__body p,
.mobile-popup__body p,
.tracking-popup__body p {
  margin-bottom: 0.5rem;
}
.referral-popup__body a,
.trial-popup__body a,
.mobile-popup__body a,
.tracking-popup__body a {
  color: #dabc64;
}
.referral-popup__body a:hover,
.trial-popup__body a:hover,
.mobile-popup__body a:hover,
.tracking-popup__body a:hover {
  color: #dabc64;
  cursor: pointer;
}
.referral-popup.tracking-popup,
.trial-popup.tracking-popup,
.mobile-popup.tracking-popup,
.tracking-popup.tracking-popup {
  width: 80rem;
  text-align: left;
}
.referral-popup.tracking-popup .tracking-popup__header,
.trial-popup.tracking-popup .tracking-popup__header,
.mobile-popup.tracking-popup .tracking-popup__header,
.tracking-popup.tracking-popup .tracking-popup__header {
  text-align: center;
}
@media (max-width: 750px) {
  .referral-popup.tracking-popup,
  .trial-popup.tracking-popup,
  .mobile-popup.tracking-popup,
  .tracking-popup.tracking-popup {
    width: 100%;
  }
}
.referral-popup__actions,
.trial-popup__actions,
.mobile-popup__actions,
.tracking-popup__actions {
  display: flex;
  justify-content: flex-end;
}
.referral-popup__actions .btn-default,
.trial-popup__actions .btn-default,
.mobile-popup__actions .btn-default,
.tracking-popup__actions .btn-default {
  min-width: 12rem;
  border: 0;
  border-radius: 0;
  background: none;
  color: #dabc64;
  font-weight: bold;
}
.referral-popup__actions .btn + .btn,
.trial-popup__actions .btn + .btn,
.mobile-popup__actions .btn + .btn,
.tracking-popup__actions .btn + .btn {
  margin-left: 1rem;
}
.referral-popup__actions .btn + .btn.btn-lg,
.trial-popup__actions .btn + .btn.btn-lg,
.mobile-popup__actions .btn + .btn.btn-lg,
.tracking-popup__actions .btn + .btn.btn-lg {
  margin-left: 4rem;
}
.referral-popup__actions .btn-lg,
.trial-popup__actions .btn-lg,
.mobile-popup__actions .btn-lg,
.tracking-popup__actions .btn-lg {
  border: 0.2rem solid #dabc64;
}
.referral-popup__actions .btn-lg:hover, .referral-popup__actions .btn-lg:active, .referral-popup__actions .btn-lg:focus,
.trial-popup__actions .btn-lg:hover,
.trial-popup__actions .btn-lg:active,
.trial-popup__actions .btn-lg:focus,
.mobile-popup__actions .btn-lg:hover,
.mobile-popup__actions .btn-lg:active,
.mobile-popup__actions .btn-lg:focus,
.tracking-popup__actions .btn-lg:hover,
.tracking-popup__actions .btn-lg:active,
.tracking-popup__actions .btn-lg:focus {
  background: #dabc64;
  color: white;
  border: 0.2rem solid #dabc64;
}
.referral-popup__actions .btn-default.btn-secondary,
.trial-popup__actions .btn-default.btn-secondary,
.mobile-popup__actions .btn-default.btn-secondary,
.tracking-popup__actions .btn-default.btn-secondary {
  margin: 0.6rem 1.2rem;
  padding: 0;
  min-width: 0;
}
.referral-popup__actions .btn-default.btn-secondary:hover, .referral-popup__actions .btn-default.btn-secondary:active, .referral-popup__actions .btn-default.btn-secondary:focus,
.trial-popup__actions .btn-default.btn-secondary:hover,
.trial-popup__actions .btn-default.btn-secondary:active,
.trial-popup__actions .btn-default.btn-secondary:focus,
.mobile-popup__actions .btn-default.btn-secondary:hover,
.mobile-popup__actions .btn-default.btn-secondary:active,
.mobile-popup__actions .btn-default.btn-secondary:focus,
.tracking-popup__actions .btn-default.btn-secondary:hover,
.tracking-popup__actions .btn-default.btn-secondary:active,
.tracking-popup__actions .btn-default.btn-secondary:focus {
  color: #dabc64;
  text-decoration: underline;
  background: none;
  border: 0;
  box-sizing: border-box;
}
.referral-popup__dismiss,
.trial-popup__dismiss,
.mobile-popup__dismiss,
.tracking-popup__dismiss {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.5rem 2rem 1rem;
  cursor: pointer;
  font-size: 2.5rem;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/ApplicationLayout/ApplicationLayout.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,YAAA;AAEF;AAAE;EAHF;IAII,gBAAA;IACA,iCAAA;EAGF;AACF;;AAEI;EADF;IAEI,iBAAA;EAEJ;AACF;;AAEA;EACE,mBAAA;EACA,2CAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;AACF;AACE;EAXF;IAYI,sBAAA;EAEF;AACF;AAAE;EACE,yDAAA;EACA,aAAA;EACA,uBAAA;AAEJ;AADI;EAJF;IAKI,UAAA;EAIJ;AACF;AADE;EACE,yDAAA;EACA,wBAAA;EACA,aAAA;AAGJ;AAAE;EACE,gBAAA;AAEJ;AAEI;EACE,kBAAA;EACA,gCAAA;AAAN;AAEM;EACE,gCAAA;AAAR;AAEQ;EACE,gCAAA;AAAV;AACU;EACE,gCAAA;AACZ;AACY;;EAEE,aAAA;AACd;;AAQA;;;;EAIE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AALF;AAOE;EAjBF;;;;IAkBI,WAAA;EADF;AACF;AAGE;;;;EACE,iBAAA;EACA,yBAAA;EACA,cDpFG;ECqFH,gBAAA;EACA,mBAAA;AAEJ;AAEI;;;;EACE,gBAAA;AAGN;AAAI;;;;EACE,qBAAA;AAKN;AAFI;;;;EACE,cDnGC;AC0GP;AANM;;;;EACE,cDrGD;ECsGC,eAAA;AAWR;AANE;;;;EACE,YAAA;EACA,gBAAA;AAWJ;AATI;;;;EACE,kBAAA;AAcN;AAXI;EARF;;;;IASI,WAAA;EAiBJ;AACF;AAdE;;;;EACE,aAAA;EACA,yBAAA;AAmBJ;AAjBI;;;;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDjIC;ECkID,iBAAA;AAsBN;AAnBI;;;;EACE,iBAAA;AAwBN;AAtBM;;;;EACE,iBAAA;AA2BR;AAvBI;;;;EACE,4BAAA;AA4BN;AA1BM;;;;;;;;;;EAGE,mBDnJD;ECoJC,YAAA;EACA,4BAAA;AAmCR;AA/BI;;;;EACE,qBAAA;EACA,UAAA;EACA,YAAA;AAoCN;AAlCM;;;;;;;;;;EAGE,cDjKD;ECkKC,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,sBAAA;AA2CR;AAtCE;;;;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;AA2CJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n#artful-client {\n  height: 100%;\n\n  @media (max-width: $tablet) {\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.ReactModal__Body--open {\n  #artful-client {\n    @media (max-width: $tablet) {\n      overflow-y: unset;\n    }\n  }\n}\n\n.application-background {\n  padding: 1rem 0 0 0;\n  background: linear-gradient(lighten($gray, 10%), $gray);\n  background: url('./wood-background.jpg');\n  min-height: calc(100% - 6rem);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n  top: 0;\n\n  @media (min-width: $laptop) {\n    padding: 1.5rem 6.5rem;\n  }\n\n  &.feature-flag-registration {\n    background-image: url('./wood-background.jpg');\n    display: flex;\n    justify-content: center;\n    @media (max-width: 1023px) {\n      padding: 0;\n    }\n  }\n\n  &.registration {\n    background-image: url('./registration-background.jpg');\n    background-position: top;\n    display: flex;\n  }\n\n  &.app-loading {\n    min-height: 100%;\n  }\n\n  &.edge {\n    .skin-wrapper {\n      position: relative;\n      min-height: calc(100% - 10.5rem);\n\n      .date-tabs-wrapper {\n        min-height: calc(100% - 12.5rem);\n\n        .split-page {\n          min-height: calc(100% - 12.5rem);\n          & > .flex-row {\n            min-height: calc(100% - 12.5rem);\n\n            .page-right,\n            .page-left {\n              height: unset;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.referral-popup,\n.trial-popup,\n.mobile-popup,\n.tracking-popup {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba($magenta, 0.9);\n  padding: 2rem 2rem;\n  z-index: 4;\n  width: 75rem;\n  margin: 0 auto;\n  color: white;\n  text-align: center;\n  font-size: 1.6rem;\n\n  @media (max-width: 750px) {\n    width: 100%;\n  }\n\n  &__header {\n    font-size: 2.5rem;\n    text-transform: uppercase;\n    color: $gold;\n    font-weight: 600;\n    margin-bottom: 1rem;\n  }\n\n  &__body {\n    &__code {\n      font-weight: 600;\n    }\n\n    p {\n      margin-bottom: 0.5rem;\n    }\n\n    a {\n      color: $gold;\n      &:hover {\n        color: $gold;\n        cursor: pointer;\n      }\n    }\n  }\n\n  &.tracking-popup {\n    width: 80rem;\n    text-align: left;\n\n    .tracking-popup__header {\n      text-align: center;\n    }\n\n    @media (max-width: 750px) {\n      width: 100%;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n\n    .btn-default {\n      min-width: 12rem;\n      border: 0;\n      border-radius: 0;\n      background: none;\n      color: $gold;\n      font-weight: bold;\n    }\n\n    .btn + .btn {\n      margin-left: 1rem;\n\n      &.btn-lg {\n        margin-left: 4rem;\n      }\n    }\n\n    .btn-lg {\n      border: 0.2rem solid $gold;\n\n      &:hover,\n      &:active,\n      &:focus {\n        background: $gold;\n        color: white;\n        border: 0.2rem solid $gold;\n      }\n    }\n\n    .btn-default.btn-secondary {\n      margin: 0.6rem 1.2rem;\n      padding: 0;\n      min-width: 0;\n\n      &:hover,\n      &:active,\n      &:focus {\n        color: $gold;\n        text-decoration: underline;\n        background: none;\n        border: 0;\n        box-sizing: border-box;\n      }\n    }\n  }\n\n  &__dismiss {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: 0.5rem 2rem 1rem;\n    cursor: pointer;\n    font-size: 2.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
